import React, { Fragment } from 'react';
import { useRouter } from 'next/router';

import { DrawerController } from '@reckon-web/drawer';

import { useOpenTaskDialog } from '../../hooks/use-open-task-dialog';

import { TaskDrawer } from './drawer';
import { TaskCreateDrawer } from './create-drawer';
import { useTaskDrawer } from './task-drawer-context';

export const TaskDrawerOpener: React.FC = () => {
  const router = useRouter();
  const openTaskDialog = useOpenTaskDialog();

  const taskId = router.query.task;
  const effectiveTaskId = React.useMemo(
    () => (Array.isArray(taskId) ? taskId[0] : taskId) || null,
    [taskId]
  );

  const { createOptions, closeCreate } = useTaskDrawer();

  return (
    <Fragment>
      <DrawerController isOpen={Boolean(taskId)}>
        <TaskDrawer
          onClose={() => {
            delete router.query.task;
            router.push(
              { pathname: router.pathname, query: router.query },
              undefined,
              {
                shallow: true,
              }
            );
          }}
          taskId={effectiveTaskId}
        />
      </DrawerController>
      <DrawerController isOpen={Boolean(createOptions)}>
        <TaskCreateDrawer
          onClose={(params) => {
            closeCreate();
            if (!params.didCancel) {
              openTaskDialog(params.newTaskId);
            }
          }}
          options={createOptions}
        />
      </DrawerController>
    </Fragment>
  );
};
